import { darken, lighten, type MantineColorScheme } from "@mantine/core";

export const DEFAULT_COLORSCHEME: MantineColorScheme = "auto";

export const SYSTEM_COLORS = {
  error: "red",
  warning: "orange",
  success: "green",
  info: "blue",
  default: "gray",
  disabled: "var(--mantine-color-gray-5)",
  primary: "primary",
  secondary: "secondary",
  white: "var(--mantine-color-white)",
  black: "var(--mantine-color-dark)",
  text: "var(--mantine-color-bright)",
  // LIGHT
  errorLight: "var(--mantine-color-red-light)",
  warningLight: "var(--mantine-color-orange-light)",
  successLight: "var(--mantine-color-green-light)",
  infoLight: "var(--mantine-color-blue-light)",
  // ENTITIES
  WORKSPACE: "gray",
  DEPLOYMENT: "violet",
  DEVICE: "indigo",
  PART: "grape",
  SERVICE_JOB: "orange",
  CASE: "pink",
  MAINTENANCE: "cyan",
  MAINTENANCE_STRATEGY: "yellow",
  CALENDAR_EVENT: "blue",
  TASK: "teal",
  CHECKLIST_TEMPLATE: "lime",
  USER: "blue",
  INVENTORY_ACTION_ADD: "green",
  INVENTORY_ACTION_REMOVE: "red",
  INVENTORY_ACTION_CHANGE: "blue",
  INVENTORY_ACTION_MOVE: "orange",
  INVENTORY_ACTION_ISOLATE: "yellow",
  INVENTORY_ACTION_ASSEMBLE: "violet",
  INVENTORY_ACTION_DISASSEMBLE: "cyan",
  ACADEMY: "yellow",
  INSIGHTS: "violet",
  FILTERS: "var(--mantine-color-secondary-filled)",
};

export const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

// https://colorbrewer2.org/#type=qualitative&scheme=Paired&n=12
const colorSet = [
  "#1f78b4",
  "#b2df8a",
  "#e31a1c",
  "#a6cee3",
  "#33a02c",
  "#fb9a99",
  "#cab2d6",
  "#fdbf6f",
  "#6a3d9a",
  "#ff7f00",
  "#ffff99",
  "#b15928",
];

export const getStableColor = (index: number) => {
  const colorSetLength = colorSet.length;
  const _index = index % colorSetLength;
  const setIteration = Math.floor(index / colorSetLength);
  const chosenColor = colorSet[_index];
  const setIterationAdjust = setIteration % 2;

  if (setIteration <= 0) return chosenColor;
  return setIterationAdjust === 0 ? darken(chosenColor, 0.3) : lighten(chosenColor, 0.3);
};
